module.exports = __webpack_public_path__ + "static/withdraw180-53ffe3437d492cbeed15f0611ea5aa3e.png";